import { useInjection } from "@linkfluence/core/di";
import { notifyError, notifySuccess } from "@linkfluence/core/notifications";
import { useMutation } from "@tanstack/react-query";
import { tr } from "@radarly/i18n";
import { UserRepo, UserRepositoryUID } from "../repositories/UserRepo";
import { useCurrentUser } from "./useCurrentUser";

export function useResetUserPassword() {
  const repository = useInjection<UserRepo>(UserRepositoryUID);
  const user = useCurrentUser();
  const { mutateAsync, data, error } = useMutation(
    () => {
      return repository.resetUserPassword(user.email);
    },
    {
      onSuccess: ({ ok }) => {
        if (ok) {
          notifySuccess(tr(user.locale, "PROFILE::RESET_PASSWORD_SUCCESS"));
        } else {
          notifyError(tr(user.locale, "PROFILE::RESET_PASSWORD_ERROR"));
        }
      },
      onError: (err: Error) => {
        notifyError(tr(user.locale, "PROFILE::RESET_PASSWORD_ERROR"));
      },
    }
  );
  return {
    onResetPassword: () => mutateAsync(),
    error: error || (data && !data.ok),
  };
}
